import React from 'react';
import HeaderMain from '../../components/HeaderMain';

/**
 * Render the setting page
 *
 * @component
 */
const Setting = () => {
  return (
    <>
      <HeaderMain
        highlightTitle={'SORRY !'}
        subtitle={'Setting page is under construction...'}
      />
    </>
  );
};

export default Setting;
